export default __webpack_public_path__ + "static/media/cloudacademy.f0f7f96b.svg";